module.exports = __webpack_public_path__ + "static/media/Circo2025_21.832f0c7d.webp";